const closedQuoteStatuses = new Set(["sent", "accepted", "declined", "cancelled"]);
const receivedQuoteStatuses = new Set(["sent", "accepted", "declined"]);

const quoteDate = (value) => {
  if (!value) return null;
  const text = String(value);
  const date = new Date(text.includes(" ") ? `${text.replace(" ", "T")}Z` : text);
  return Number.isNaN(date.getTime()) ? null : date;
};

export function quotePeriodStart(period, now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (period === "week") start.setDate(start.getDate() - (start.getDay() + 6) % 7);
  if (period === "month") start.setDate(1);
  if (period === "year") { start.setMonth(0); start.setDate(1); }
  return start;
}

export function quoteKpis(items, period = "month", now = new Date()) {
  const start = quotePeriodStart(period, now);
  const inPeriod = (value) => {
    const date = quoteDate(value);
    return Boolean(date && date >= start && date <= now);
  };
  return {
    total: items.filter((item) => inPeriod(item.createdAt)).length,
    inProgress: items.filter((item) => !closedQuoteStatuses.has(item.status)).length,
    received: items.filter((item) =>
      (item.proposalSentAt || receivedQuoteStatuses.has(item.status)) &&
      inPeriod(item.proposalSentAt || item.updatedAt),
    ).length,
  };
}
